import { observable, decorate, action, runInAction } from 'mobx';
import Auth from '../modules/auth/Auth';

class Associations {
    associations = [];
    userHasAssociation = false;
    saAssociations = [];

    getUserHasAssociation = async () => {
        let [aRes, aErr] = await Auth.superAuthFetch(`/api/CustomUsers/getUserHasAssociation`, null);
        if (aErr || !aRes) return;

        runInAction("update values after fetching data", () => {
            this.userHasAssociation = aRes;
        });
    }

    getAssociationsNames = async () => {
        let [aRes, aErr] = await Auth.superAuthFetch(`/api/Associations/getAssociationsNames`, null, true);
        if (aErr || !aRes || !aRes.length) { console.log("aErr", aErr); return; }

        runInAction("update values after fetching data", () => {
            this.associations = aRes;
        });
    }

    getSAAssociations = async () => {
        let [aRes, aErr] = await Auth.superAuthFetch(`/api/Associations/getSAAssociations`, null, true);
        if (aErr || !aRes || !aRes.length) { console.log("aErr", aErr); return; }

        runInAction("update values after fetching data", () => {
            this.saAssociations = aRes;
        });
    }
}

decorate(Associations, {
    associations: observable,
    getAssociationsNames: action,
    userHasAssociation: observable,
    getUserHasAssociation: action,
    saAssociations: observable,
    getSAAssociations: action
});

export default new Associations;
